import * as echarts from "echarts"
import EChartsController from "../echarts_controller"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
    small: { type: Boolean, default: false },
    showMax: { type: Boolean, default: false },
    showLegend: { type: Boolean, default: false },
    showTitle: { type: Boolean, default: true },
    legendBottom: { type: Number, default: 0 },
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)
    this.renderChart(
      this.chart,
      this.dataValue,
      this.smallValue,
      this.showMaxValue,
      this.showLegendValue,
      this.showTitleValue,
      this.legendBottomValue,
    )
  }

  renderChart(
    chart,
    collection,
    small,
    showMax,
    showLegend,
    showTitle,
    legendBottom,
  ) {
    const collectionMax = collection.reduce(
      (max, name) => (name.events_count > max.events_count ? name : max),
      collection[0],
    )

    chart.setOption({
      tooltip: {
        trigger: "item",
        confine: true,
      },
      legend: {
        bottom: legendBottom,
        left: "center",
        width: "100%",
        orient: "horizontal",
        itemWidth: 12,
        itemHeight: 12,
        icon: "circle",
        itemGap: 8,
        textStyle: {
          color: "#F3F3F3B2",
          fontSize: 11,
          overflow: "truncate",
        },
        show: showLegend,
      },
      title: {
        left: "center",
        top: "center",
        text: small
          ? null
          : `${collectionMax.events_count_percentage.toFixed(2)}%`,
        subtext: showMax ? collectionMax.name : null,
        itemGap: -1,
        textStyle: {
          color: "#f3f3f3",
          fontSize: 14,
          fontWeight: "bold",
        },
        subtextStyle: {
          color: "#B6C7D8",
          fontSize: 13,
        },
        show: showTitle,
      },
      series: [
        {
          type: "pie",
          radius: small ? ["30%", "70%"] : ["50%", "80%"],
          center: ["50%", "50%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 0,
            borderColor: "#0D1926",
            borderWidth: 2,
          },
          label: {
            show: false,
          },
          emphasis: {
            label: {
              show: false,
            },
          },
          labelLine: {
            show: false,
          },
          data: collection.map(({ name, events_count, color }) => {
            return {
              name,
              value: events_count,
              itemStyle: {
                color: color,
              },
            }
          }),
        },
      ],
    })
  }
}
